import { useEffect, useState } from "react";

const useTypingEffect = (
  text: string,
  duration: number,
  isTypeByLetter = false,
  style?: React.CSSProperties,
) => {
  const items = isTypeByLetter ? text.split("") : text.split(" ");

  return items.map((item, i) => {
    return (
      <span
        className="blur-scale-in hp-pb-0"
        key={i}
        style={{ ...style, animationDelay: i * duration + "ms", opacity: 0 }}
      >
        {item} &nbsp;
      </span>
    );
  });
};

export default useTypingEffect;
